export default {
  methods: {
    /**
     * 画面上部にメッセージを表示する。ただし、既に表示されているメッセージを閉じる
     * 前提：このmixinを呼び出し元でelement-uiが使えること
     * @param  {String} type (success/warning/info/error)
     * @param  {String} message
     * @param  {String} duration optional
     * @param  {String} closeable optional
     */
    announceMessage(type, message, optParam = { duration: null, closeable: true }) {
      ElMessage.closeAll();
      switch (type) {
        case 'success':
          ElMessage({
            message: message,
            type: type,
            showClose: optParam.closeable || false,
            duration: optParam.duration || 3000,
          });
          break;
        case 'warning':
          ElMessage({
            message: message,
            type: type,
            showClose: optParam.closeable || false,
            duration: optParam.duration || 0,
          });
          break;
        case 'info':
          ElMessage({
            message: message,
            type: type,
            showClose: optParam.closeable || false,
            duration: optParam.duration || 0,
          });
          break;
        case 'error':
          ElMessage({
            message: message,
            type: type,
            showClose: optParam.closeable || false,
            duration: optParam.duration || 0,
          });
          break;
        default:
          console.log('message_type_error');
      }
    },
    closeMessages() {
      ElMessage.closeAll();
    },
  },
};
